export default {
  // Options.jsx
  items_per_page: '/странице',
  label_items_per_page: 'Items / page',
  jump_to: 'Перейти',
  jump_to_confirm: 'подтвердить',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'Назад',
  next_page: 'Вперед',
  prev_5: 'Предыдущие 5',
  next_5: 'Следующие 5',
  prev_3: 'Предыдущие 3',
  next_3: 'Следующие 3',
};
